<template>
  <div class="signin d-flex flex-column justify-content-center align-items-center h-auto p-4 scroll-content">
    <div class="login-form step-container info-container">
      <div class="d-flex flex-column justify-content-between text-center">
        <div class="d-flex justify-content-center text-center">
          <img
            class="secondary-logo pb-3 mt-5"
            :src="this.config ? this.config.organizationLogo : ''"
            alt=""
          />
        </div>

        <div v-if="!isCanceled" class="d-flex flex-column mb-4 mt-5">
          <h5>{{ $t("thanks") }}</h5>
          <h6>{{ $t("thank-you-subtitle") }}</h6>
        </div>
        <div v-else class="d-flex flex-column align-items-center mb-4 mt-5">
          {{ $t("appointment-canceled") }}

          <button
            @click="goToIndex"
            type="button"
            class="btn btn-primary w-50 mt-5"
          >
            {{
              appointmentInfo.newPatient
                ? $t("return-to-index")
                : $t("return-to-appointments")
            }}
          </button>
        </div>
      </div>
      <b-container v-if="!isCanceled">
        <b-row>
          <b-col md="6" sm="12">
            <div>
              {{ $t("datetime") }}
            </div>
            <div class="info">
              {{ appointmentDate }}
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <div>
              {{ $t("location") }}
            </div>
            <div class="info">
              {{
                appointmentInfo.placeOfServiceEnabled
                  ? appointmentInfo.data.placeOfService.name
                  : appointmentInfo.data.location.name
              }}
              <div v-if="!appointmentInfo.placeOfServiceEnabled">
                {{
                  appointmentInfo.data.location.addressLine1 +
                    ` ` +
                    appointmentInfo.data.location.addressLine2 +
                    ` ` +
                    ` ` +
                    appointmentInfo.data.location.city +
                    ` ` +
                    appointmentInfo.data.location.zipcode
                }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <div>
              {{ $t("clinician") }}
            </div>
            <div class="info">
              {{ appointmentInfo.data?.provider.fullName }}
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <div>
              {{ $t("service") }}
            </div>
            <div class="info">
              {{ appointmentInfo.data?.service.name }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="button-container">
              <button
                v-if="appointmentInfo.newPatient === false"
                @click="returnToPatientPortal"
                class="btn btn-primary my-button"
              >
                Return to Appointments
              </button>

              <button
                @click="cancelAppointment"
                class="btn btn-primary my-button on-right"
              >
                {{ $t("step-cancel-appointment") }}
              </button>

              <button
                v-if="appointmentInfo.newPatient === true"
                @click="returnToHomePage"
                class="btn btn-primary px-5 mr-5"
              >
                Go back to home page
              </button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { appointmentsServer } from "../../server/appointments";
import { dateWhitFormat } from "../../helpers/date";
import { mapState } from "vuex";
export default {
  name: "AppointmentRequestFinish",
  props: ["appointmentInfo"],
  data() {
    return {
      isCanceled: false
    };
  },
  methods: {
    async cancelAppointment() {
      this.$dialog
        .confirm(
          {
            title: this.$t("cancel-apointment-confirmation")
          },
          {
            view: "confirm-delete",
            removeButtonTitle: this.$t("yes")
          }
        )
        .then(async () => {
          const canceled = await appointmentsServer.cancelAppointment(
            this.appointmentInfo.data.id
          );
          canceled.status === 204 ? (this.isCanceled = true) : null;
        })
        .catch(() => null);
    },
    goToIndex() {
      this.$router.push(
        !this.appointmentInfo.newPatient ? "/" : "/appointments"
      );
    },
    returnToPatientPortal() {
      this.$router.push("/appointments");
    },
    returnToHomePage() {
      this.$router.push("/");
    }
  },
  computed: {
    ...mapState({
      config: state => state.session.systemSettings
    }),
    appointmentDate() {
      return dateWhitFormat(
        this.appointmentInfo.data.date ||
          this.appointmentInfo.data.startDateTime,
        "dddd, MMMM DD, YYYY hh:mm A"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.secondary-logo {
  height: 100px;
}

.info {
  color: #208de2;
}

.signin {
  position: relative;
  background: linear-gradient(
    to bottom,
    #13609b,
    #208de2 47.5%,
    #f5f6f9 47.5%,
    #f5f6f9
  );

  .logo-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 235px));
  }

  .info-container{
    padding: 2rem;
    max-width: 800px;
  }

  .button-container{
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
  }

  .my-button{
    margin-right: 3rem;
    padding-left: 3rem;
    padding-right: 3rem;
  }

   @media (max-width: 576px) {
      .signin {
        position: relative;
        background: linear-gradient(
          to bottom,
          #13609b,
          #208de2 47.5%,
          #f5f6f9 47.5%,
          #f5f6f9
        );
        overflow: hidden;
      }

      .info-container{
        padding: 1rem;
        max-width: 100%;
      }

      .my-button{
        margin-right: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
      }

      .my-button.on-right{
        padding-left: 1rem;
        padding-right: 1rem;
      }
   }
   @media (max-width: 320px) {
      .info-container{
        padding: 1rem;
        max-width: 100%;
      }

      .button-container{
        margin: 0;
        margin-top: 1rem;
        padding: 0;
        display: flex;
        justify-content: center;
      }

      .my-button{
        margin-right: 2px;
        padding-left: 1rem;
        padding-right: 1rem;
      }
   }
}
</style>
